import {
  ModalErrorProps,
  ModalSuccessProps,
  ModalDownloadProps,
  ModalColumnProps,
  ModalDialogProps,
  ModalChildrenCloseProps,
  ModalActionProps,
  ModalBaseProps,
  ModalSessionProps,
  ModalAdviceProps,
} from '../documentation/Modal';
import ModalClose from '../components/Commons/Modal/ModalClose';
import ModalColumns from '../components/Commons/Modal/ModalColumns';
import ModalDialog from '../components/Commons/Modal/ModalDialog';
import ModalDownload from '../components/Commons/Modal/ModalDownload';
import ModalError from '../components/Commons/Modal/ModalError';
import ModalSuccess from '../components/Commons/Modal/ModalSuccess';
import ModalChildrenClose from '../components/Commons/Modal/ModalChildrenClose';
import ModalService from '../services/components/ModalService/ModalService.service';
import ModalAction from '../components/Commons/Modal/ModalAction';
import ModalSession from '../components/Commons/Modal/ModalSession';
import ModalBase from '../components/Commons/Modal/ModalBase';
import ModalAdvice from '../components/Commons/Modal/ModalAdvice';

/**
 * @param {ModalErrorProps} props
 */
export const openModalError = (props) => ModalService.open(ModalError, props);
/**
 * @param {ModalSuccessProps} props
 */
export const openModalSuccess = (props) => ModalService.open(ModalSuccess, props);
/**
 * @param {ModalDownloadProps} props
 */
export const openModalDownload = (props) => ModalService.open(ModalDownload, props);
/**
 * @param {ModalColumnProps} props
 */
export const openModalColumns = (props) => ModalService.open(ModalColumns, props);
/**
 * @param {ModalDialogProps} props
 */
export const openModalDialog = (props) => ModalService.open(ModalDialog, props);
/**
 * @param {ModalChildrenCloseProps} props
 */
export const openModalChildrenClose = (props) => ModalService.open(ModalChildrenClose, props);
/**
 * @param {ModalActionProps} props
 */
export const openModalAction = (props) => ModalService.open(ModalAction, props);
/**
 * @param {ModalBaseProps} props
 */
export const openModalClose = (props) => ModalService.open(ModalClose, props);
/**
 * @param {ModalSessionProps} props
 */
export const openModalSession = (props) => ModalService.open(ModalSession, props);
/**
 * @param {ModalBaseProps} props
 */
export const openModalBase = (props) => ModalService.open(ModalBase, props);
/**
 * @param {ModalAdviceProps} props
 */
export const openModalAdvice = (props) => ModalService.open(ModalAdvice, props);
